import PhysicianSelector from './PhysicianSelector';

export default PhysicianSelector;
